import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['emissionInput', 'emission', 'unit']

  connect() {
    this.setUnit()
  }

  // private

  setUnit() {
    const selectedEf = this.findSelectedEf()

    if (selectedEf) {
      this.unitTarget.innerText = selectedEf.dataset.unit
    }
  }

  findSelectedEf() {
    return this.emissionTargets.find(emission => emission.classList.contains('active'))
  }

  setEmission(event) {
    const id = event.target.parentNode.dataset.id
    this.emissionInputTarget.value = id
    this.unitTarget.innerText = event.target.parentNode.dataset.unit
    this.emissionTargets.forEach(target => target.classList.remove('active'))
    event.target.parentNode.classList.add('active')
  }
}
